exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-list .farm-assign {\n  justify-content: space-between;\n  margin-left: 1px;\n  margin-right: 3px;\n  margin-bottom: 10px; }\n\n.card-list .farm-select {\n  width: 400px;\n  margin-left: 330px;\n  align-items: flex-end !important; }\n\n.card-list .search-container-searchbox .input-with-icon {\n  width: 400px; }\n  .card-list .search-container-searchbox .input-with-icon input {\n    height: 40px; }\n  .card-list .search-container-searchbox .input-with-icon i {\n    padding-top: 10px; }\n\n.network_icon {\n  width: 20px;\n  height: 20px;\n  margin-right: 5px; }\n", ""]);

// exports
